module.exports = "<input class=\"form-control p-r-5 p-l-5\" type=text> ";